export { AttachmentPrimitiveRoot as Root } from "./AttachmentRoot";
export { AttachmentPrimitiveThumb as unstable_Thumb } from "./AttachmentThumb";
export { AttachmentPrimitiveName as Name } from "./AttachmentName";
export { AttachmentPrimitiveRemove as Remove } from "./AttachmentRemove";
